<template>
    <div class="container">
        <p class="main_title">
            GAGA PRIVACY STATEMENT
        </p>

        <p class="contentBlack">Last Updated:Oct 23,2024</p>
        
        <p class="contentBlack">
            This privacy statement explains our collection,use,and disclosure of personal data. It applies to 
            the Gaga service,which is offered by JUYI GLOBAL INC, and to our controlled affiliates and 
            subsidiaries (collectively"We", "Us" , or "Gaga"). References to our "services"in this statement include our Gaga websites and apps.
        </p>

        <span class="content">Table of Contents</span>
        <span class="content">-Personal Data We Collect</span>
        <span class="content">-Cookies,Web Beacons,and Other</span>


        <div style="height: 24px;"></div>
        <span class="content">Technologies</span>
        <span class="content">-Our Use of Personal Data</span>
        <span class="content">-Our Disclosures of Personal Data</span>
        <span class="content">-Your Personal Data Choices and Options</span>
        <span class="content">-California Privacy Rights and Disclosures</span>
        <span class="content">-Retention of Personal Data</span>
        <span class="content">-Location of Personal Data Processing</span>
        <span class="content">-Security of Personal Data</span>
        <span class="content">-Changes to This Privacy Statement</span>
        <span class="content">-How to Contact Us</span>



        <div style="height: 24px;"></div>
        <p class="contentBlack">PERSONAL DATA WE COLLECT</p>
        <span class="content">The personal data we collect depends on how you interact with us,the services you use,and the choices you make.</span>



        <div style="height: 24px;"></div>
        <span class="content">We collect information about you from different sources and in various ways when
            you use our services,including information you provide directly,information collected automatically,
            information from third-party data sources,and data we infer or generate from other data.
        </span>



        <div style="height: 24px;"></div>
        <span class="content">Information you provide directly.We collect personal data you provide to us.
            For example,we collect the following categories of personal data that you provide directly to us:
        </span>



        <div style="height: 24px;"></div>
        <span class="content">-Identifiers,such as name and profile name,email address,address,and online identifiers.</span>
        <span class="content">-Characteristics of Protected Classifications,such as your sex or gender,sexual
            orientation,or gender identity that you provide in using Gaga,or other details that we do not ask
            for but that you choose to volunteer that may reveal characteristics of protected classifications
            under applicable law.
        </span>
        <span class="content">-Commercial Information,such as information about purchases you make in connection with Gaga.</span>
        <span class="content">-Internet Information,such as your browsing,search,and usage details in connection with Gaga,
            when coming to or leaving the Gaga services online,or interacting with Gaga advertisements online.
        </span>
        <span class="content">-Geolocation Data that is approximate,such as the state,province,or 
            country you access the services from.
        </span>
        <span class="content">-Visual Data,such as photographs or videos you share in connection with Gaga.</span>
        <span class="content">-Inferences that we make based on the personal data we collect,such as about your interests.</span>
        <span class="content">-Other Personal Data,including "Payment Information"such as your credit card number,
            expiration date,and other payment details when you make purchases in connection with Gaga;
            "Characteristics"such as your physical characteristics and descriptions you provide in 
            connection with Gaga and your profile;and"User Content"such as photos,profile information,
            messages and communications,and other information you receive or provide in connection with Gaga.
        </span>
        <span class="content">-Sensitive Personal Data,which may include:Payment Information as described above,
            Racial or ethnic origin,religious or philosophical beliefs,or union membership,that we do not ask 
            for but that you choose to volunteer in using Gaga("Volunteered Sensitive Data),Contents of messages 
            that you send to or receive from other Gaga users in connection with use of the services("Message 
            Contents"),and Your sexual orientation,or details about your sex life that we do not ask for but 
            that you choose to volunteer in using Gaga("Sexual Orientation and Volunteered Data").
        </span>
        <span class="content">Information we collect automatically.When you use our services,we collect 
            some information automatically.For example,we may collect the following categories of personal 
            data automatically:
        </span>
        <span class="content">-Identifiers about you and your device(s).When you use our services we automatically 
            log your Internet Protocol (IP)address and information about your device,including device 
            identifiers(such as MAC address);device type;and your device operating system,browser,and 
            other software including type,version,language,settings,and configuration.As further described 
            in the Cookies,Web Beacons,and Other Technologies section below,our services automatically 
            collect and store identifiers like the types described here using Technologies.
        </span>
        <span class="content">-Geolocation Data that is approximate,such as the state,province,or country 
            you access the services from.
        </span>
        <span class="content">-Internet Information such as your browsing,search,and usage details in 
            connection with Gaga and when coming to or leaving the Gaga services online or interacting 
            with Gaga advertisements online.
        </span>
        <span class="content">Information we create or generate.We infer new information from other data 
            we collect,including the following categories of personal data:
        </span>
        <span class="content">-Inferences that we make automatically on the personal data we collect,such 
            as about your interests.
        </span>
        <span class="content">-Other Personal Data such as when you are using the services which may be 
            displayed to other Gaga users.s
        </span>
        <span class="content">Information we obtain from third-party sources.We may also obtain any of 
            the categories of personal data described above from third parties,such as:
        </span>
        <span class="content">-third-party partners,which may help us to collect any of the categories of 
            personal data describe above,
        </span>
        <span class="content">-service providers,which may help us to collect any of the categories of personal data described above,and</span>
        <span class="content">-publicly available sources,which we may use to obtain Other Personal Data such as 
            Characteristics like demographic data about you.
        </span>
        <span class="content">When you are asked to provide personal data,you may decline.And you may use web 
            browser or operating system controls to prevent certain types of automatic data collection.But 
            if you choose not to provide or allow information that is necessary for certain services or 
            features,those services or features may not be available or fully functional.
        </span>


        <div style="height: 24px;"></div>
        <p class="contentBlack">COOKIES,WEB BEACONS,AND OTHER TECHNOLOGIES</p>


        <div style="height: 24px;"></div>
        <span class="content">We use cookies,web beacons,and other technologies(collectively,"Technologies")to collect personal data.</span>


        <div style="height: 24px;"></div>
        <span class="content">What are cookies,web beacons,and other technologies?</span>


        <div style="height: 24px;"></div>
        <span class="content">Cookies are small text files placed by a website and stored by your browser on 
            your device.A cookie can later be read when your browser connects to a web server in the same domain 
            that placed the cookie.The text in a cookie contains a string of numbers and letters that may uniquely 
            identify your device and can contain other information as well.This allows the web server to recognize 
            your browser over time,each time it connects to that web server.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Web beacons are electronic images(also called single-pixel or clear GIFs)that are 
            contained within a website.When your browser opens a web page that contains a web beacon,it 
            automatically connects to the web server that hosts the image(typically operated by a third party).This 
            allows that web server to log information about your device and to set and read its own cookies.In the 
            same way,third-party content on a website(such as embedded videos,plug-ins,or ads)results in your 
            browser connecting to the third-party web server that hosts that content.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Mobile apps can contain software that enables app providers to access information about you</span>
        <span class="content">and your device that you use in connection with apps.</span>


        <div style="height: 24px;"></div>
        <span class="content">How do we and our partners use cookies,web beacons,and other technologies?</span>


        <div style="height: 24px;"></div>
        <span class="content">We,our third-party partners,and our service providers,use Technologies in our 
            services,including our websites and apps,to collect personal data.For example,personal data about 
            your online activities over time and across different websites or online services may be collected.We 
            use this information for a variety of purposes,such as to store your preferences and settings,enable 
            you to sign-in,analyze how our websites and apps perform,track your interaction with the site or 
            app,develop inferences,deliver and tailor interest-based advertising,combat fraud,and fulfill other 
            legitimate purposes.We and our partners also share the information we collect or infer with third 
            parties for these purposes.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">What controls are available?</span>


        <div style="height: 24px;"></div>
        <span class="content">-Browser cookie controls.Most web browsers are set to accept cookies by 
            default.If you prefer,you can go to your browser settings to learn how to delete or reject 
            cookies.If you choose to delete or reject cookies,this could affect certain features or services 
            of our website.If you choose to delete cookies,settings and preferences controlled by those 
            cookies,including advertising preferences,may be deleted and may need to be recreated.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Mobile advertising ID controls.iOS and Android operating systems provide options to limit tracking 
            and/or reset the advertising IDs.
        </span>



        <div style="height: 24px;"></div>
        <span class="content">-Do Not Track.Some browsers have incorporated "Do Not Track"(DNT)features that 
            can send a signal to the websites you visit indicating you do not wish to be tracked.Because 
            there is not a common understanding of how to interpret the DNT signal,our websites do not 
            currently respond to browser DNT signals.
        </span>


        <p class="contentBlack">OUR USE OF PERSONAL DATA</p>
        <!-- <div style="height: 24px;"></div> -->
        <span class="content">We use the personal data we collect for purposes described in this privacy 
            statement or as otherwise disclosed to you.Below are examples of the types of uses we make of 
            personal data,and the corresponding categories of personal data(which are detailed in the 
            "Personal Data We Collect"section above).
        </span>
        <!-- table -->

        <div style="height: 24px;"></div>
        <div class="table-container">
            <table>
            <thead>
                <tr>
                <th style="color: #FFEBF8">Purposes of Use</th>
                <th style="color: #FFEBF8">Categories of Personal Data</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items" :key="item.id">
                <td style="color: #FFEBF8;">{{ item.column1 }}</td>
                <td style="color: #FFEBF8;">{{ item.column2 }}</td>
                </tr>
            </tbody>
            </table>
        </div>



        <div style="height: 24px;">We combine data we collect from different sources for these purposes and 
            to give you a more seamless,consistent,and personalized experience.
        </div>



        <p class="contentBlack">OUR DISCLOSURES OF PERSONAL DATA</p>
        <span class="content">We disclose personal data with your consent,or as we deem necessary for our 
            business purposes including to provide the services to you.In addition,we disclose each of the 
            categories of personal data described in the Personal Data We Collect section above,with the 
            types of third parties described below,for the following business purposes:
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Gaga service users.Information about you and your use of the Gaga services,such 
            as your profile information and when you are using the services,will be shared within the Gaga 
            services,including for other users to see.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Service providers.We disclose personal data to vendors or agents working on 
            our behalf for the purposes described in this statement.For example,personal data may be shared 
            with companies we've hired to provide customer service support or assist in protecting and securing 
            our systems and services.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Third-party partners.We may disclose personal data to third-party partners,such 
            as if you request or consent to us doing so.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Payment processors and others.We disclose personal data to entities that provide 
            us with payment processing,fraud prevention,or other financial services.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Affiliates.We enable access to personal data across our subsidiaries,affiliates,and 
            related companies,for example,where we share common data systems or where access helps to provide our
            services and operate our business.
        </span>



        <div style="height: 24px;"></div>
        <span class="content">-Corporate transactions. We may disclose personal data as part of a corporate 
            transaction or proceeding such as a merger, financing, acquisition, bankruptcy,dissolution,or a 
            transfer,divestiture,or sale of all or a portion of our business or assets.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Legal and law enforcement.We share personal data with third parties when we 
            believe that doing so is necessary to comply with applicable law or respond to valid legal 
            process,including from law enforcement or other government entities.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">-Security,safety,and protecting rights.We may disclose personal data if we 
            believe it is to:protect our customers and others,for example to prevent spam or attempts to 
            commit fraud,or to help prevent the loss of life or serious injury of anyone;
        </span>


        <div style="height: 24px;"></div>
        <span class="content">operate and maintain the security of our services,including to prevent or 
            stop an attack on our computer systems or networks;or protect the rights or property or 
            ourselves or others.Including enforcing our agreements,terms, and policies.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Third party service providers,such as analytics,personalization,fraud,security,and 
            advertising companies also collect personal data through our website and apps using Technologies,as 
            further described in the Cookies,Web Beacons,and Other Technologies section above.For example,we use 
            Google Analytics on our website to help us understand how users interact with our website;you can 
            learn how Google collects and uses information at www.google.com/policies/privacy/partners.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Finally,we may share de-identified or aggregate information in accordance with 
            applicable law,and in general,we do not treat such information as personal data where that is 
            consistent with applicable law.
        </span>



        <p class="contentBlack">YOUR PERSONAL DATA CHOICES AND OPTIONS</p>
        <span class="content">Access and To Know.If you wish to access personal data about you,you may access 
            your account by logging into the Gaga services you use and viewing some of the personal 
            data associated with your account.You also have a right to request to know additional 
            information about our collection,use,disclosure,or sale of personal data about you,including 
            to request a copy of the personal data we have about you.Note that we have provided much of 
            this information in this privacy statement.You may make such a "request to know"by contacting us 
            at <span style="color: red;">contactgagaapp@gmail.com</span>
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Choices for Technologies.See the Cookies,Web Beacons,and Other Technologies 
            section above for details about choices and options for Technologies.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Correction.You may request correction of certain personal data about 
            you.You can correct some personal data by logging into the Gaga services you use and 
            using options available to update personal data associated with your account. You can also 
            contact us at <span style="color: red;">contactgagaapp@gmail.com</span>
        </span>



        <div style="height: 24px;"></div>
        <span class="content">Deletion.You can request that we delete personal data under certain 
            circumstances,subject to a number of exceptions.To make a request to delete,you can contact us 
            at <span style="color: red;">contactgagaapp@gmail.com</span>
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Email preferences.You can choose whether to receive promotional emails 
            from us.If you receive promotional emails from us and would like to stop,you can do so by 
            following the directions in those emails.These choices do not apply to certain informational 
            communications including surveys and mandatory service communications.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Verification,Honoring Requests,and Nondiscrimination.To the extent permitted by 
            applicable law for the choices and options for Access and To Know,Correction,and Deletion,we 
            reserve the right to charge a fee or decline requests that are unreasonable or excessive,where 
            providing the data would be prohibited by law or could adversely affect the privacy or other 
            rights of another person,or where we are unable to authenticate you as the person to whom the 
            data relates.We will not discriminate against you for making requests about the choices and 
            options described in this section.In general,we authenticate you by requiring you to validate 
            requests by responding from the email address we have associated with your information or account.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Applicable law may allow you to designate an authorized agent to make some 
            of the request types noted in this section on your behalf.
        </span>



        <div style="height: 24px;"></div>
        <span class="content">Before accepting such a request from an agent,we may require the agent to 
            provide proof you have authorized it to act on your behalf,and we may need you to verify 
            your identity directly with us and/or confirm that you authorized the agent to act on your
            behalf.
        </span>


        <p class="contentBlack">CALIFORNIA PRIVACY RIGHTS AND DISCLOSURES</p>
        <span class="content">If you are a California resident,California Civil Code section 1798.100 et seq,known as the 
            California Consumer Privacy Act("CCPA”),requires us to describe the categories of personal data we"sell"to 
            or"share"with third parties.We do not"sell"or "share"your personal data as those terms are defined 
            by the CCPA,and have not done so in the past 12 months.We do not knowingly sell or share the personal 
            information of minors under 16 years of age.
        </span>


        <div style="height: 24px;"></div>
        <span class="content">Under California Civil Code section 1798.83,also known as the 
            "Shine the Light"law,California residents who have provided personal information to a 
            business with which the individual has established a business relationship for personal,family,or 
            household purposes may request information about whether the business has disclosed personal 
            information to any third parties for the third parties direct marketing purposes.We do not disclose 
            personal information to any third parties for their direct marketing purposes as defined by this 
            law.California Customers may request further information about our compliance with this law by 
            e-mailing <span style="color: red;">contactgagaapp@gmail.com</span>. Please note that businesses are required to respond to one 
            request per California Customer each year and may not be required to respond to requests
            made by means other than through the designated e-mail address.
        </span>


        <p class="contentBlack">RETENTION OF PERSONAL DATA</p>
        <span class="content">We retain personal data for as long as necessary to provide the services and 
            fulfill the transactions you have requested,comply with our legal obligations,resolve disputes,
            enforce our agreements,and for other legitimate and lawful business purposes.Because these needs 
            can vary for different data types in the context of different services,actual retention periods 
            can vary significantly based on criteria such as user expectations or consent,the sensitivity of 
            the data,options you have to delete personal data,and our legal or contractual obligations.
        </span>


        <p class="contentBlack">LOCATION OF PERSONAL DATA PROCESSING</p>
        <span class="content">The personal data we collect may be stored and processed in your country 
            or region,or in any other country where we or our affiliates,subsidiaries,service providers,or 
            third-party partners process data.For example,personal data will be processed in the United 
            States,Singapore,China,and Hong Kong.We take commercially reasonable efforts with the intent of 
            processing and protecting personal data according to the provisions of this statement and applicable 
            law wherever the data are located.
        </span>


        <p class="contentBlack">SECURITY OF PERSONAL DATA</p>
        <span class="content">We take what we believe to be reasonable and appropriate steps to help 
            protect personal data from unauthorized access,use,disclosure,alteration,and destruction.To 
            help us protect personal data,we request that you use a strong password and never share your 
            password with anyone or use the same password with other sites or accounts.
        </span>


        <p class="contentBlack">CHANGES TO THIS PRIVACY STATEMENT</p>
        <span class="content">We will update this privacy statement when necessary to reflect changes in our services,how 
            we use personal data,or applicable law.When we post changes to the statement,we will revise 
            the "Last Updated"date at the top of the statement. If we make material changes to the statement,we 
            will provide notice or obtain consent regarding such changes as may be required by law.
        </span>


        <p class="contentBlack">HOW TO CONTACT US</p>
        <span class="content">If you have a privacy concern,complaint,or a question for Gaga,
            please contact us at <span style="color: red;">contactgagaapp@gmail.com</span>
        </span>
        <div style="height: 120px;"></div>

    




    </div>
</template>

<script>
export default {
    data() {
        return {
            appName: '',
            companyName: '',

            companyMail: '',
            companyPhone: '',
            companyAddress: '',

            items: [
                { id: 1, column1: 'Product and service delivery.To provide and deliver our services,including maintaining accounts and services functionality,and troubleshooting,improving,and personalizing the services. Business operations.To operate our business,such as by processing payments,accounting,improving our internal operations,securing our systems,detecting and responding to fraudulent or illegal activity,monitoring for and responding to violations of our policies and guidelines,meeting our legal obligations,responding to legal and law enforcement claims and investigations,and facilitating our business transactions (such as mergers or acquisitions).', column2: 'Identifiers,Characteristics and Protected Classifications,Commercial Information,Internet Information,Geolocation Data,Visual Data,Inferences,Other Personal Data Sensitive Information:Payment Information,Volunteered Sensitive Data,Message Contents,and Sexual Orientation and Volunteered Data Identifiers,Characteristics and Protected Classifications,Commercial Information,Internet Information,Geolocation Data,Visual Data,Inferences,Other Personal Data Sensitive Information:Payment Information,Volunteered Sensitive Data,Message Contents,and Sexual Orientation and Volunteered Data' },
                { id: 2, column1: 'Product improvement,development and research. To develop new services or features, analyze use of the services,and to conduct research.', column2: 'Identifiers,Characteristics and Protected Classifications,Commercial Information,Internet Information,Geolocation Data,Visual Data,Inferences,Other Personal Data Sensitive Information:Volunteered Sensitive Data,Message Contents,and Sexual Orientation and Volunteered Data' },
                { id: 3, column1: 'Personalization. To understand you and your preferences to enhance your experience and enjoyment using our services.', column2: 'Identifiers,Characteristics and Protected Classifications,Commercial Information,Internet Information,Geolocation Data,Visual Data,Inferences,Other Personal Data Sensitive Information:Sexual Orientation and Volunteered Data' },
                { id: 4, column1: 'Customer support.To provide customer support,investigate and resolve disputes,and respond to your questions.', column2: 'Identifiers,Characteristics and Protected Classifications,Commercial Information,Internet Information,Geolocation Data,Visual Data,Inferences,Other Personal Data Sensitive Information:Payment Information,Volunteered Sensitive Data,Message Contents,and Sexual Orientation and Volunteered Data' },
                { id: 5, column1: 'Communications.To send you information,including messages,confirmations,updates,and support and administrative messages. Marketing.To communicate with you about new services,offers,promotions,rewards,contests, upcoming events, and other information about our services.', column2: 'Identifiers,Commercial Information,Other Personal Data Identifiers,Commercial Information,Internet Information,Geolocation Data,Inferences,Other Personal Date' },
                { id: 6, column1: 'Advertising. To display advertising to you.', column2: 'ldentifiers,Commercial Information,Internet Information,Geolocation Data, inferences,Other Personal Data' },
                // ...更多数据
            ],

            itemsa: [
                { id: 1, column1: '122', column2: '333' },
            ]
        }
    },

    created() {
        this.checkURLParams();
    },

    methods: {
         checkURLParams() {
            this.checkName();
        },

        checkName(edition) {
            this.appName = 'Gaga';
            this.companyName = 'Juyi Global Co., Limited';
            // this.companyAddress = 'B37, 17/F Chiap King Industrial Building 114 King Fuk Street San Po Kong Hong Kong';
            this.companyMail = 'jyhq2024@hotmail.com';
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    /* width: 100vw; */
    /* width: 100%; */
    background-color: #04001B;
}

.content {
    font-size: 15px;
    color: #FFEBF8;
}
.contentBlack {
    font-size: 16px;
    color: #FFEBF8;
    font-weight: 700;
}

.main_title {
    font-size: 20px;
    color: red;
    font-weight: 700;
    align-items: center;
    align-self: center;
}

.table-container {
  /* max-width: 100vw; */
  overflow-x: auto;
}

table {
  /* 表格宽度设置为父容器宽度 */
  width: 100%;
  border-collapse: collapse;
  /* box-sizing: border-box; */
}

th, td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
}
</style>